import * as React from 'react';
import { i as invariantIntlContext } from '../utils-BIG_B-Jx-BNoSNLtk.js';
import { C as Context } from './injectIntl-BtqeBzQq-DKO65rGD.js';

function useIntl() {
  var intl = React.useContext(Context);
  invariantIntlContext(intl);
  return intl;
}

export { useIntl as u };
//# sourceMappingURL=useIntl-BLE3wELi-CV9fXVbx.js.map
